import { useEffect, useRef } from 'react';
import {
  Card,
  IconButton,
  TextArea,
} from '@resultadosdigitais/tangram-components';
import { Play } from '@resultadosdigitais/tangram-react-icons';
import AutosizeTextArea from 'react-textarea-autosize';
import styled from 'styled-components';

import { useUI } from '../context/ui';
import { UseChatHelpers } from '../hooks/use-chat';
import { useEnterSubmit } from '../hooks/use-enter-submit';

const Container = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  padding-top: 20px;
  z-index: 1000;
  background: rgb(225, 228, 232);
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );

  ${Card.style} {
    > div {
      width: 100%;
      max-width: 780px;
      margin: 0 auto;
      padding-bottom: var(--size-spacing-03);
      padding-top: var(--size-spacing-03);
    }
  }
`;

const ThemeAwareAutosizeTextArea = styled(AutosizeTextArea)`
  width: 100%;
  resize: none;
  outline: none;
  min-height: 48px;
  padding: 12px 0;
`;

const Form = styled.form`
  display: flex;
  align-items: center;
  gap: var(--size-spacing-04);
`;

export interface PromptProps {
  value: UseChatHelpers['input'];
  isLoading: UseChatHelpers['isLoading'];
  onChange: UseChatHelpers['handleInputChange'];
  onSubmit: UseChatHelpers['handleSubmit'];
}

export const Prompt = ({
  value,
  isLoading,
  onChange,
  onSubmit,
}: PromptProps) => {
  const { ui } = useUI();
  const { formRef, onKeyDown } = useEnterSubmit(isLoading);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (ui.open) textareaRef.current?.focus();
  }, [ui.open]);

  return (
    <Container>
      <Card>
        <Form ref={formRef} onSubmit={onSubmit}>
          <ThemeAwareAutosizeTextArea
            autoFocus
            ref={textareaRef}
            tabIndex={0}
            rows={2}
            spellCheck={false}
            placeholder="Escreva a sua pergunta"
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            className={TextArea.styles}
          />
          <IconButton type="submit" disabled={isLoading || value === ''}>
            <Play title="Enviar" />
          </IconButton>
        </Form>
      </Card>
    </Container>
  );
};
